import React, { Fragment } from "react"
import styled from "@emotion/styled"

import ReaderBlock from "./reader-block"
import { graphql, useStaticQuery } from "gatsby"

import facepaint from "facepaint"
const breakpoints = [576, 768, 992, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const Container = styled.div`
  text-align: center;
`
const Header = styled.h2`
  color: #c7a542;
  text-align: center;
  font-weight: bold;
  ${mq({
    fontSize: ["8.0vw", "3.25rem", "3.25rem", "3.25rem"],
  })}
`
const Readers = styled.div`
  padding: 0;
`
const NextReadersLatest = () => {
  const data = useStaticQuery(graphql`
    query NextReadersLatestQuery {
      allLeaderCsv(filter: { year: { eq: "2020" } }) {
        edges {
          node {
            id
            name
            photo
            post_title
            post_url
            title
            year
            publish_date
          }
        }
      }
    }
  `)
  return (
    <Container>
      <Header>NEXT LEADERS</Header>
      <Readers>
        {data.allLeaderCsv.edges.map((leader, index) => {
          const layout = index % 2 === 0 ? "left" : "right"
          const bg = `${index + 1}_bg.png`
          const f_key = `Fragment-NextReadersLatest-${leader.node.id}`
          const key = `NextReadersLatest-${leader.node.id}`
          const anchor_link = `anchor_${leader.node.year}_${index}`
          return (
            <Fragment key={f_key}>
              <ReaderBlock
                anchor_link={anchor_link}
                className="idNnext"
                key={key}
                {...leader.node}
                layout={layout}
                bg={bg}
              />
            </Fragment>
          )
        })}
      </Readers>
    </Container>
  )
}

export default NextReadersLatest
